module.exports = __webpack_public_path__ + "static/media/googlePin4.c880cc8b.svg";